import moment from 'moment';
import { auth, fieldValue } from './firebase';
import { convertTopicDiscussion, topicRef, forumRef } from './forum';

const commentCollection = 'comments';
const replyCollection = 'replies';

export const fetchDiscussion = async (id: string): Promise<Discussion> => {
  const discussionRef = topicRef.doc(id);
  const [topicSnapshot, commentsSnapshot, relatedReplies] = await Promise.all([
    discussionRef.get(),
    forumRef
      .collection(commentCollection)
      .where('topicId', '==', id)
      .orderBy('createdAt', 'asc')
      .get(),
    fetchReplies(id),
  ]);
  const topic = convertTopicDiscussion({
    ...topicSnapshot.data(),
    ref: topicSnapshot,
  });
  const comments = await Promise.all([
    ...commentsSnapshot.docs.map((doc) => {
      const fetch = async () => {
        const replies = relatedReplies.filter(
          (reply) => reply.parentId === doc.id
        );
        const comment: Commentation = {
          comment: convertComment({ ...doc.data(), ref: doc }),
          replies,
        };
        return comment;
      };
      return fetch();
    }),
  ]);
  return { topic, comments };
};
const fetchReplies = async (topicId: string): Promise<IComment[]> => {
  const repliesSnapshot = await forumRef
    .collection(replyCollection)
    .where('topicId', '==', topicId)
    .orderBy('createdAt', 'asc')
    .get();
  if (repliesSnapshot.docs.length === 0) return [];
  return repliesSnapshot.docs.map((doc) =>
    convertComment({ ...doc.data(), ref: doc })
  );
};

export const convertComment = (
  data: firebase.default.firestore.DocumentData
): IComment => {
  const { author, avatar, content, uid, parentId, topicId } = data;
  return {
    author,
    avatar,
    content,
    createdAt: moment(data.createdAt.toDate()),
    uid,
    docId: data.ref.id,
    parentId,
    topicId,
  };
};
export const submitComment = async (comment: IComment): Promise<IComment> => {
  const discussionRef = topicRef.doc(comment.parentId);
  const id = forumRef.collection(commentCollection).doc().id;
  await Promise.all([
    forumRef
      .collection(commentCollection)
      .doc(id)
      .set({ ...comment, createdAt: fieldValue.serverTimestamp() }),
    discussionRef.set(
      { commentCount: fieldValue.increment(1) },
      { merge: true }
    ),
  ]);
  return { ...comment, docId: id };
};

export const submitReply = async (comment: IComment): Promise<IComment> => {
  const replyRef = forumRef.collection(replyCollection);
  const id = replyRef.doc().id;
  await Promise.all([
    replyRef
      .doc(id)
      .set({ ...comment, createdAt: fieldValue.serverTimestamp() }),
  ]);
  return { ...comment, docId: id };
};

export const submitReport = async (id: string) => {
  const discussionRef = topicRef.doc(id);
  const reportRef = discussionRef.collection('reports');
  const reportSnapshot = await reportRef.doc('users').get();
  const data = reportSnapshot.data();
  if (!reportSnapshot.exists || !data?.users.includes(auth.currentUser?.uid)) {
    await Promise.all([
      discussionRef.set(
        { reportCount: fieldValue.increment(1) },
        { merge: true }
      ),
      reportRef.doc('users').set({
        users: fieldValue.arrayUnion(auth.currentUser?.uid),
      }),
    ]);
  }
};
